import useTranslation from "@/hook/useTranslation";
import Image from "next/image";
import {
  FaFacebookF,
  FaYoutube,
  FaTwitter,
  FaInstagram,
  FaChevronUp,
} from "react-icons/fa";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-gradient-to-r from-gray-900 to-green-900 text-white py-12 footer-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        {/* 🔹 Middle Section (4 Columns) */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mt-12 text-left top-footer">
          {/* 🟢 Column 1: Company Info */}
          <div>
            <Image
              src="/images/footer-logo.png"
              alt="Logo"
              width={120}
              height={40}
            />
            <p className="mt-2 text-gray-400 text-sm">{t("footerDesc")}</p>
          </div>

          {/* 🔵 Column 2: Useful Links */}
          <div>
            <h3 className="text-lg font-semibold">{t("usefulLinks")}</h3>
            <ul className="mt-2 space-y-2 text-gray-300 text-sm">
              {[t("menuHome"), t("menuNews"), t("menuContact")].map((link) => (
                <li key={link}>
                  <a href="#" className="hover:text-white flex items-center">
                    {[FaChevronUp].map((Icon, index) => (
                      <span key={index} className="hover:text-white text-2xl">
                        <Icon />
                      </span>
                    ))}
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 🟡 Column 3: Account Links */}
          <div>
            <h3 className="text-lg font-semibold">{t("accountLinks")}</h3>
            <ul className="mt-2 space-y-2 text-gray-300 text-sm">
              {[
                "Accounts Overview",
                "Demo Account",
                "ECN Account",
                "Individual Account",
                "Professional Account",
                "VIP Account",
              ].map((link) => (
                <li key={link}>
                  <a href="#" className="hover:text-white flex items-center">
                    {[FaChevronUp].map((Icon, index) => (
                      <span key={index} className="hover:text-white text-2xl">
                        <Icon />
                      </span>
                    ))}
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 🔴 Column 4: Social Media & App Links */}
          <div>
            <h3 className="text-lg font-semibold">{t("socialConnect")}</h3>
            <div className="flex space-x-4 mt-2">
              {[FaFacebookF, FaYoutube, FaTwitter, FaInstagram].map(
                (Icon, index) => (
                  <a key={index} href="#" className="hover:text-white text-2xl">
                    <Icon />
                  </a>
                )
              )}
            </div>
          </div>
        </div>

        {/* 🔹 Bottom Section */}
        <div className="mt-12 flex flex-col md:flex-row justify-between items-center text-gray-400 text-sm bottom-footer">
          <p className="mt-4 md:mt-0">
            © 2025 <span className="text-green-400">FinSight Group</span> Made
            with Expertise, All Rights Reserved.
          </p>

          <div className="flex space-x-4">
            <a href="#" className="hover:text-white">
              Privacy Policy
            </a>
            <span>・</span>
            <a href="#" className="hover:text-white">
              Terms & Conditions
            </a>
            <span>・</span>
            <a href="#" className="hover:text-white">
              Legal
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
